import { memo } from "react";
import { HStack, Text, useColorModeValue } from "@chakra-ui/react";

type InfoRowProps = {
  label: string;
  value: string;
  highlight?: boolean;
  large?: boolean;
};

export const InfoRow = memo(({
  label,
  value,
  highlight,
  large,
}: InfoRowProps) => {
  const subtitleColor = useColorModeValue("gray.500", "gray.400");
  const textColor = useColorModeValue("gray.800", "white");

  return (
    <HStack justify="space-between" w="100%" py={1.5}>
      <Text fontSize={large ? "md" : "sm"} color={subtitleColor}>
        {label}
      </Text>
      <Text
        fontSize={large ? "lg" : "sm"}
        fontWeight={highlight || large ? "bold" : "medium"}
        color={highlight ? "brand.500" : textColor}
      >
        {value}
      </Text>
    </HStack>
  );
});

InfoRow.displayName = "InfoRow";
